// Spread onto any <input> / <textarea> that captures information we never want a
// browser or password manager to offer to save — customer names, phones, emails,
// and addresses on the estimate / contract / job-order forms.
//
// `autocomplete="off"` on its own is not enough: Chrome ignores it for
// contact/address fields (it still shows "Save this address?") and every major
// third-party manager ignores it too. Each manager has its own opt-out hook, so
// we set all of them plus the standard attributes.
//
//   import { noAutofill } from '../../utils/noAutofill';
//   <input {...noAutofill} value={customer.name} onChange={...} />
//
// Note: spread this BEFORE any explicit autoComplete/name you want to keep, or
// after if you want these to win. These forms use `twp-*` field names already,
// which also helps keep Chrome's heuristics from classifying them.
export const noAutofill = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
  'data-1p-ignore': '',       // 1Password
  'data-lpignore': 'true',    // LastPass
  'data-form-type': 'other',  // Dashlane
  'data-bwignore': '',        // Bitwarden
};

// Same idea at the container level — put on a <form> or the wrapper <div> around
// a group of fields. Some managers (1Password, Dashlane) also honor these on an
// ancestor, which catches fields we might otherwise miss.
export const noAutofillContainer = {
  'data-1p-ignore': '',
  'data-lpignore': 'true',
  'data-form-type': 'other',
  'data-bwignore': '',
};

export default noAutofill;
